import { render, staticRenderFns } from "./systemRoleEdit.vue?vue&type=template&id=39ac4a0f&scoped=true"
import script from "./systemRoleEdit.vue?vue&type=script&lang=js"
export * from "./systemRoleEdit.vue?vue&type=script&lang=js"
import style0 from "./systemRoleEdit.vue?vue&type=style&index=0&id=39ac4a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac4a0f",
  null
  
)

export default component.exports